module.exports = __webpack_public_path__ + "img/cityPartner2.b99c0689.png";